// import {showExistingSimulationInCartPopUp, simulationAlreadyInCart} from "../../Core/ShoppingCart/shopping_cart.js";
const ShoppingCart = require("./../../Core/ShoppingCart/shopping_cart");
const ContribVisualiser = require("./../../Core/Simulator/contrib_prevusualize");
const { renderCusageEtasWarning } = require("./../../Core/Simulator/cusage_etas_warning");
const initPacBasket = require("./../../vteTools/Simulation/pac-basket");

$(document).ready(function () {

    if ($('#simulation_vehicule_electrique').length > 0) {
        return;
    }
    /*ELIGIBLE WORK FIELD RECUPERATION*/
    // Categories vars
    var catContainer = $('#categories-container');
    var catTrigger = $('select[name*=eligible_category]');
    var currentValue = lower_first_word(catTrigger.find('option').first().text());
    var newValue;

    var workInput = $('select[name*=eligible_work]');
    var categoryId = catTrigger.find('option:first').attr('value');

    // Work vars
    var workTrigger = $('select[name*=eligible_work]');
    var workContainer = $('.input-container');
    var currentId = workTrigger.find('option:selected').attr('value');

    // Form vars
    var submitTrigger = $('input[type*=submit]');
    var form = $('form[name*=front_simulation]');
    var inputContainers;
    var canSubmit;

    var enrCdpContainer = $('.CDP_ENR').removeClass('col-md-6');
    var enrCombCdpContainer = $('.CDP_ENR_COMB').removeClass('col-md-6');

    var enrContainer = $('#enr_container');
    var enrCombContainer = $('#enr_comb_container');

    var hideInputsConditions = [
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [322]) === -1)
                    return false;
                return true;
            },
            hideList: ['RRC_ERR']
        },
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [115, 116, 204]) === -1)
                    return false;

                var LOG = $('form[name*=front_simulation]').find("input[name*=LOG]:checked");
                var logVal = LOG.length > 0 ? LOG.val() : null;
                return logVal == 1;
            },
            hideList: []
        },
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [111]) === -1)
                    return false;
                return true;
            },
            hideList: ["P3_COPE"]
        },
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [348]) === -1) {
                    return false;
                }
                $('input[name*="PER_MORALE_TYPE"][value="2"]').trigger('click');
                $('input[name*="PER_MORALE_TYPE"]').parents('.field-container').css('display','none');
                return true;
            },
            // hideList: ["PER_MORALE_TYPE"]
        },
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [341, 342]) !== -1) {
                    $('input[name="front_simulation[LOG]"]').parents('.field-container').hide();
                    $('select[name="front_simulation[etiquette_energetique_logement]"]').parents('.field-container').hide();

                    return true;
                }

                return false;
            },
            // hideList: ['LOG']
        },
        {
            cond: function () {
                if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [341, 342]) === -1) {
                    return false;
                }
                $('#question-rg-have-made-audit').removeClass('hidden');
                $('[name="RG_HAVE_MADE_AUDIT"]').on('change', function (event) {
                    if ($(this).val() == 1) {
                        $('#rg-ask-audit').addClass('hidden');
                    } else {
                        $('#rg-ask-audit').removeClass('hidden');
                    }
                });
                // $('[name="RG_HAVE_MADE_AUDIT"][value="0"]').trigger('click');
                $('select[name*="CLASS_ENR_INIT"]').find('option[value="1"]').remove();//A
                $('select[name*="CLASS_ENR_INIT"]').find('option[value="2"]').remove();//B
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="1"]').remove();//A
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="6"]').remove();//F
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="7"]').remove();//G
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="5"]').remove();//E
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="6"]').remove();//F
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="7"]').remove();//G

                return true;
            },
            // hideList: []
        }
    ];

    var hideWorkConditions = [
        // Résidentiel
        {
            'triggerName': 'LOG',
            'cond': function (val) {
                return val === '2';
            },
            'hideList': [113, 114],
            "message": "<p>Ces travaux ne sont pas éligibles en Appartement.</p>"
        },
        {
            'triggerName': 'P3_ETAS',
            'cond': function (val) {
                if (!val)
                    return;

                var typePac = $('form[name*=front_simulation]').find("input[name*=P3_TYPE_PAC]:checked");
                var typePacVal = typePac.length > 0 ? typePac.val() : null;


                var alertMsg = null;
                var returnresult = false;

                if (val.length > 0) {
                    if (typePacVal == 0) {
                        alertMsg = "Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées (Efficacité énergétique saisonnière doit être supérieure ou égale à 126)";
                        returnresult = val < 126;
                    } else if (typePacVal == 1) {
                        alertMsg = "Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées (Efficacité énergétique saisonnière doit être supérieure ou égale à 111)";
                        returnresult = val < 111;
                    }
                }
                if (alertMsg && returnresult) {
                    alert(alertMsg);
                    $('form[name*=front_simulation]').find("input[name*=P3_ETAS]").val('');
                    typePac.removeAttr('checked');
                }
                return returnresult;
            },
        },
        {
            // BAR-TH-168 : surface de capteurs ≥ 8 m² (chauffage + ECS) / ≥ 2 m² (ECS seule).
            'triggerName': 'SURF_CAPT_SOL',
            'cond': function (val) {
                if (!val || val.length === 0)
                    return;

                var form = $('form[name*=front_simulation]');
                var usageField = form.find("[name*=USAGE_168]");
                var usageVal = usageField.is('select') ? usageField.val() : usageField.filter(':checked').val();

                var seuil = null;
                if (usageVal == 1) seuil = 8;        // Chauffage et eau chaude sanitaire
                else if (usageVal == 2) seuil = 2;   // Eau chaude sanitaire seule

                var returnresult = false;
                if (seuil !== null)
                    returnresult = parseFloat(val) < seuil;

                if (returnresult) {
                    $('<div>').append('<p>La surface de capteurs est insuffisante pour être éligible à la Prime énergie.</p>').dialogMp();
                    form.find("input[name*=SURF_CAPT_SOL]").val('');
                }
                return returnresult;
            },
        },
        {
            // BAR-TH-162 : surface de capteurs hybrides ≥ 6 m² (seuil fixe, sans dépendance à l'usage).
            'triggerName': 'SURF_CAPT_HYB',
            'cond': function (val) {
                if (!val || val.length === 0)
                    return;

                var form = $('form[name*=front_simulation]');
                var returnresult = parseFloat(val) < 6;

                if (returnresult) {
                    $('<div>').append('<p>La surface de capteurs prévue est insuffisante pour être éligible à la Prime énergie (6 m² minimum).</p>').dialogMp();
                    form.find("input[name*=SURF_CAPT_HYB]").val('');
                }
                return returnresult;
            },
        }
    ];

    this.inputs = [];
    this.works = [];
    var pthis = this;


    function checkEligibility() {
        for (var i = 0; i < hideWorkConditions.length; i++) {
            var conf = hideWorkConditions[i];
            if (!conf) continue;

            var triggerName = conf.triggerName;
            var condHandler = conf.cond;

            var trigger = $("input, select").filter("[name$='" + triggerName + "]']"); //name end with

            // On prend le type de trigger en considération
            var type = trigger.attr('type');

            let value;

            if (type && type.toLowerCase() == 'radio') {
                value = trigger.filter(":checked").val();
            } else {
                value = trigger.val();
            }

            // Vérifions si la condition est remplie => si elle l'est on devra masquer tous les éléments listés
            var doHide = condHandler(value);

            if (doHide){
                if($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), conf.hideList) != -1) {
                    var popupContainer = $('<div>');
                    popupContainer.append(conf.message);
                    popupContainer.dialogMp();
                }
            }
        }
    };

    function applyInputFilters() {
        var inputsToHide = [];
        for (var i = 0; i < hideInputsConditions.length; i++) {
            var conf = hideInputsConditions[i];
            var doHide = conf.cond();
            if (doHide)
                inputsToHide = inputsToHide.concat(conf.hideList);
        }
        return inputsToHide;
    };

    function createOptions() {
        workInput.empty();
        var worksToHide = [];
        $.each(pthis.works, function (key, value) {
            if ($.inArray(parseInt(value.id), worksToHide) == -1) {
                var option = $('<option>')
                    .attr('value', value.id)

                    .text(value.title)
                ;

                if (currentId == value.id) {
                    option.attr('selected', 'selected')
                }

                workInput.append(option);
            }
        });
    }

    catTrigger.change(function () {
        categoryId = $(this).val();
        currentId = workTrigger.find('option:selected').attr('value');

        newValue = lower_first_word($(this).find('option:selected').text());
        newValue = newValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        if (currentValue != newValue) {
            updateContainer(newValue);
        }

        $.ajax(Routing.generate('api_get_category_works', {
            type: 'particulier-3p',
            category_id: categoryId
        }))
            .done(function (data) {
                pthis.works = data;
                createOptions();
                if (window._preselectedEligibleWorkId) {
                    workTrigger.val(window._preselectedEligibleWorkId);
                    window._preselectedEligibleWorkId = null;
                }
                workTrigger.change();
            });

    });

    function updateContainer(value) {
        var currentClass = '.' + currentValue;
        catContainer.find(currentClass)
            .removeClass(currentValue)
            .addClass(value);

        currentValue = value;
    }

    function lower_first_word(str) {
        var asArray = str.split(" ");
        return asArray[0].toLowerCase();
    }

    workTrigger.change(function () {
        currentId = $(this).find('option:selected').attr('value');

        //bar-th-163 be closed on 01/01/2025
        // var date_31_12_2024 = new Date(2024,11,31); // month between 0-11
        // if (currentId == 317 &&  new Date() < date_31_12_2024) {
        //     canSubmit = false;
        //     $('#bar-th-163-closing-error-modal').dialogMp();
        // }
        //RENO GLOBALE 174/175
        if (currentId == 341 || currentId == 342) {

            var nbEtapeHideShowContainer = $('[name*="[FIRST_DOSSIER_REF]"], [name*="[CLASS_ENR_STEP1]"]').parents('.field-container');
            if ($('[name*="[ETAPE_2E"]:checked').val() == 2) {
                nbEtapeHideShowContainer.show();
            } else {
                $('select[name*="[CLASS_ENR_STEP1]"]').prop('selectedIndex', -1);
                nbEtapeHideShowContainer.hide();
            }
            $('[name*="[ETAPE_2E"]').on('change', function (event) {
                if ($(this).val() == 2) {
                    nbEtapeHideShowContainer.show();
                } else {
                    $('select[name*="[CLASS_ENR_STEP1]"]').prop('selectedIndex', -1);
                    nbEtapeHideShowContainer.hide();
                }
            });
            $('select[name*="CLASS_ENR_INIT"]').on('change', function () {
                var selectedVal = parseInt($(this).val());
                var target = $('select[name*="CLASS_ENR_APRES"], select[name*="CLASS_ENR_STEP1"]');
                // hide all options
                target.find('option').hide();
                // show options from 1 to selected value
                for (var i = 1; i < selectedVal - 1; i++) { //2 saut
                    target.find('option[value="' + i + '"]').show();
                }
                $('select[name*="[CLASS_ENR_STEP1]"]').prop('selectedIndex', -1);
            });
            $('select[name*="CLASS_ENR_STEP1"]').on('change', function () {
                var selectedVal = parseInt($(this).val());
                var target = $('select[name*="CLASS_ENR_APRES"]');
                // hide all options
                target.find('option').hide();
                // show options from 1 to selected value
                for (var i = 1; i < selectedVal; i++) { //1 saut
                    target.find('option[value="' + i + '"]').show();
                }
            });
        }

        $.ajax(Routing.generate('api_get_work_fields', {
            slug: 'particulier-3p',
            id: currentId
        }))
            .done(function (data) {
                pthis.inputs = data;
                if (isBarTh164()) {
                    enrCdpContainer.show();
                    enrCombCdpContainer.show();
                    enrContainer.show();
                    enrCombContainer.show();
                } else if (hasEnrCdpConditions()) {
                    /*enrContainer.before(enrCdpContainer.show()).hide().addClass('no-visibility');
                    enrCombContainer.before(enrCombCdpContainer).hide().addClass('no-visibility');
                    enrCdpContainer.change();*/
                    enrCdpContainer.show();
                    enrCombCdpContainer.show();
                    enrContainer.hide();
                    enrCombContainer.hide();
                } else {
                    /*if (!enrCombCdpContainer.hasClass('no-visibility') && !enrCdpContainer.hasClass('no-visibility')) {
                        enrCdpContainer.before(enrContainer.show()).hide().addClass('no-visibility');
                        enrCombCdpContainer.before(enrCombContainer).hide().addClass('no-visibility');
                        enrContainer.change();
                    }*/
                    enrCdpContainer.hide();
                    enrCombCdpContainer.hide();
                    enrContainer.show();
                    enrCombContainer.show();
                }

                displayInputs();
                checkEligibility();
                scheduleCusageEtasWarningRefresh();
                toggleVuVehiclesSection();
                togglePacBasketSection();
                toggleVehicleCategoryQuestion117();
            });
    });

    // Panier de PAC des fiches BAR-TH-178/179/180 et BAT-TH-162/163/164 (module partagé avec le simulateur PRO)
    var togglePacBasketSection = initPacBasket(function () {
        return parseInt(workTrigger.find('option:selected').attr('value'));
    });

    //TRA-EQ-114 v83 — section véhicules utilitaires dynamique
    var VU_WORK_ID_114 = 219;

    function toggleVuVehiclesSection() {
        var section = $('#VU_VEHICLES_SECTION');
        if (!section.length) return;

        var $p3NbrCar = $('#P3_NBR_CAR');

        var workId = parseInt(workTrigger.find('option:selected').attr('value'));
        if (workId !== VU_WORK_ID_114) {
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
            return;
        }

        // Pour work 219 v83 : seules les options 1 (léger) et 2 (utilitaire léger) sont pertinentes
        $('select[name$="[CAT_VEHICLE]"]').find('option[value="3"], option[value="4"], option[value="5"], option[value="6"]').hide();

        // CAT_VEHICLE = 1 → véhicule léger : P3_NBR_CAR visible, section VU masquée
        // CAT_VEHICLE = 2 → véhicule utilitaire léger : P3_NBR_CAR masqué, section VU visible
        var catVal = parseInt($('select[name$="[CAT_VEHICLE]"]').val());

        if (catVal === 2) {
            $p3NbrCar.hide().find('input, select').attr('disabled', 'disabled');
            section.show();
            section.find('.vu-vehicle-row:visible').find('input, select').removeAttr('disabled');
            section.find('.vu-vehicle-row:hidden').find('input, select').attr('disabled', 'disabled');
        } else {
            $p3NbrCar.show().find('input, select').removeAttr('disabled');
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
        }
    }

    $(document).on('change', 'select[name$="[CAT_VEHICLE]"]', function () {
        toggleVuVehiclesSection();
    });

    $('#vu-add-row').on('click', function () {
        var next = $('.vu-row-extra:hidden').first();
        if (next.length) {
            next.show();
            next.find('input, select').removeAttr('disabled');
        }
        if (!$('.vu-row-extra:hidden').length) { $(this).hide(); }
    });

    $(document).on('click', '.vu-row-remove', function () {
        var row = $(this).closest('.vu-vehicle-row');
        row.find('select').val('');
        row.find('input[type=number], input[type=text]').val(1);
        row.find('input[type=radio]').prop('checked', false);
        row.find('input, select').attr('disabled', 'disabled');
        row.hide();
        $('#vu-add-row').show();
    });
    //fin TRA-EQ-114 v83

    function hasEnrCdpConditions() {
        if ($.inArray(parseInt(workTrigger.find('option:selected').attr('value')), [111, 113, 114, 227, 306, 307, 338, 339]) != -1)
            return true;

        return false;
    }

    function isBarTh164() {
        if (parseInt(workTrigger.find('option:selected').attr('value')) == 327)
            return true;

        return false;
    }

    function displayInputs() {
        resetInputs();

        var inputsToHide = applyInputFilters();

        $.each(pthis.inputs, function (key, value) {
            if ($.inArray(value.name, inputsToHide) == -1) {

                let inputName = "front_simulation[" + value.name + "]";

                var input = $('input[name="' + inputName + '"]');

                if (!input.length)
                    input = $('select[name="' + inputName + '"]');

                input.closest('.field-container').removeClass('no-visibility');

            }
        });
    }

    function resetInputs() {
        $.each(workContainer.find('.field-container'), function () {
            $(this).addClass('no-visibility');
        });
    }

    function toggleCusageEtasWarning() {
        var cusageInputs = $('input[name="front_simulation[CUSAGE]"]');
        if (!cusageInputs.length) {
            return;
        }

        renderCusageEtasWarning({
            cusageContainer: cusageInputs.first().closest('.field-container'),
            selectedCategoryId: parseInt(catTrigger.val(), 10),
            selectedWorkId: parseInt(workTrigger.find('option:selected').attr('value'), 10),
            selectedCusageValue: parseInt(cusageInputs.filter(':checked').val(), 10)
        });
    }

    function scheduleCusageEtasWarningRefresh() {
        setTimeout(function () {
            toggleCusageEtasWarning();
        }, 0);

        setTimeout(function () {
            toggleCusageEtasWarning();
        }, 250);
    }

    // function dossierRefCheck() {
    //     //barth174/175
    //     if (currentId == 341 || currentId == 342) {
    //         let dossierRefInput = $('[name$="FIRST_DOSSIER_REF]"]');
    //         let dossier_ref = dossierRefInput.val().trim();
    //         if (dossier_ref && $('[name$="NB_ETAPE]"]:checked').val() == 2) {
    //             $('input[type=submit]').after('<img class="loader" style="display:unset;" src="https://cdn.v2.primesenergie.fr/images/16-ajax-loader.gif" alt=""/>');
    //             let data = {dossier_ref: dossier_ref}
    //             var url = Routing.generate('api_check_first_dosser_reference');
    //             $.ajax({
    //                 url: url,
    //                 data: data,
    //                 type: "POST",
    //                 async: false,
    //                 success: function (data, status) {
    //                     console.log('success');
    //                     return =  true;
    //                 },
    //                 error: function (data, jqXHR, status, errorThrown) {
    //                     $('input[type=submit]').siblings('.loader').remove();
    //                     if (dossierRefInput.siblings('.error-msg').length > 0) {
    //                         dossierRefInput.siblings('.error-msg').html(JSON.parse(data.responseText).error);
    //                     } else {
    //                         dossierRefInput.after('<p class="error-msg" style="top: 45px; left: 0;">'+JSON.parse(data.responseText).error+'</p>');
    //                     }
    //                     dossierRefInput.parent().parent().addClass('error');
    //                     dossierRefInput.focus();
    //                     console.log('error');
    //                     dossierRefFlag = false;
    //                 },
    //             })//end ajax
    //         }
    //     }
    // }

    // Désactive tous les inputs des champs masqués avant soumission (évite la validation Symfony des questions conditionnelles)
    form.on('submit', function () {
        form.find('.field-container.no-visibility, .field-container:hidden').find('input, select, textarea').prop('disabled', true);
    });

    form.find('input[type=submit]').click(function (e) {
        var itemId = window.location.href.split('/').pop();

        if (canSubmit) {
            return;
        } else {
            e.preventDefault();
            // dossierRefCheck();
            let response = ShoppingCart.simulationAlreadyInCart(currentId);

            if (!response.exists || response.item_id == itemId) {
                inputContainers = $(".field-container.no-visibility");

                $.each(inputContainers, function () {
                    var conditions = $(this).has('input[name*=_token]').length + $(this).has('input[name*=quotation_date]').length +
                        $(this).has('input[name*=P3_ETAS]').length + $(this).has('input[name*=P3_COPE]').length
                        + $(this).has('input[name*=CDP_ENR_COMB]').length + $(this).has('input[name*=ENR_COMB]').length;
                    if (conditions == 0) {
                        $(this).attr('disabled');
                        $(this).remove();
                    }
                });
                var workId = parseInt(workTrigger.find('option:selected').attr('value'));

                if (workId == 348 && parseInt($('input[name*="[is_entreprise]"]:checked').val()) != 1 && parseInt($("input[name*='NB_VELOS]']").val()) > 2) { //TRA-EQ-130
                    if ($('#napp-control-modal').length > 0) {
                        setTimeout(function () {
                            $('#nb_velos-control-modal').dialogMp();
                        }, 1000);
                        $("input[name*='NB_VELOS]']").parents('.field-container').addClass('error');
                    }
                } else if (workId == 204 && parseInt($("input[name*='NAPP]']").val()) > 1 && parseInt($("input[name*='LOG]']:checked").val()) == 1) { //BAR-TH-127
                    if ($('#napp-control-modal').length > 0) {
                        setTimeout(function () {
                            $('#napp-control-modal').dialogMp();
                        }, 1000);
                        $("input[name*='NAPP]']").parents('.field-container').addClass('error');
                    }
                } else if (workId == 342 && parseInt($("input[name*='PRIVATE_AREA]']:checked").val()) == 2 ) { //BAR-TH-175
                    if ($('#private_area-control-modal').length > 0) {
                        setTimeout(function () {
                            $('#private_area-control-modal').dialogMp();
                        }, 1000);
                        $("input[name*='PRIVATE_AREA]']").parents('.field-container').addClass('error');
                    }
                } else if ((workId == 341 || workId == 342) && parseInt($("input[name*='LOG_LOCATAIRE]']:checked").val()) == 1 ) { //BAR-TH-174_175
                    if ($('#log_locataire-control-modal').length > 0) {
                        setTimeout(function () {
                            $('#log_locataire-control-modal').dialogMp();
                        }, 1000);
                        $("input[name*='LOG_LOCATAIRE]']").parents('.field-container').addClass('error');
                    }
                // PE-985-v2 : blocage si residence principale (RES_PRINCIPALE == 1 = OUI) ET LOC_AGE == 2 ET etiquette initiale E/F/G (CLASS_ENR_INIT >= 5)
                } else if ((workId == 341 || workId == 342) && parseInt($("input[name*='RES_PRINCIPALE]']:checked").val()) == 1 && parseInt($("input[name*='LOC_AGE]']:checked").val()) == 2 && parseInt($("select[name*='CLASS_ENR_INIT]']").val()) >= 5) { //BAR-TH-174_175
                    if ($('#loc_age-control-modal').length > 0) {
                        setTimeout(function () {
                            $('#loc_age-control-modal').dialogMp();
                        }, 1000);
                        $("select[name*='CLASS_ENR_INIT]']").parents('.field-container').addClass('error');
                    }
                } else {
                    canSubmit = true;
                    $(this).trigger('click');
                }
            } else {
                canSubmit = false;
                ShoppingCart.showExistingSimulationInCartPopUp(response.edit_url, response.eligible_work_title);
            }
        }
    });


    if ($('#confirmModal').length > 0) {
        let formValidate = $('form[name*=app_user_registration]');
        formValidate.on('submit', function (e) {
            e.preventDefault(); // Bloque la soumission normale
            $('#confirmModal').modal('show');
            // Bouton "Retour"
            $('#modal-back').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
            });
            // Bouton "Confirmer"
            $('#modal-confirm').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
                // Soumission native (évite les doubles submit)
                formValidate[0].submit();
            });
        });
        $('.marypopin-close').on('click', function () {
            $('#confirmModal').modal('hide');
        });
    }


    resetInputs();
    catTrigger.change();
    workTrigger.change();
    checkEligibility();
    scheduleCusageEtasWarningRefresh();

    // form.find('select, input[type=radio], input[type=text]').change(function () {
    //     // displayInputs();
    // });

    $("[name*='LOG'],[name*='P3_ETAS'],[name*='P3_TYPE_PAC']").change(function () {
        createOptions();
        workTrigger.change();
    });

    form.on('change', 'input[name="front_simulation[CUSAGE]"]', function () {
        toggleCusageEtasWarning();
    });

    $(window).on('load', function () {
        scheduleCusageEtasWarningRefresh();
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
        if (!settings || !settings.url) {
            return;
        }

        if (settings.url.indexOf('api_get_category_works') !== -1 || settings.url.indexOf('api_get_work_fields') !== -1) {
            scheduleCusageEtasWarningRefresh();
        }
    });

    /*DEPT MAP SELECTOR*/
    var deptSelect = $('select[name*=DEPT]');
    deptSelect.change(function () {
        if ($(this).val() == 0 || $(this).val() > 96) {
            $('#mb-current').attr('class', 'mb');
        } else {
            var text = $.trim(deptSelect.find("option:selected").text());
            var dept = text.substring(0, 2);
            $("#frenchMap").find("a").each(function () {
                if ($(this).data('departements').indexOf(dept) >= 0) {
                    var className = $(this).attr('class') + "b";
                    if ($(this).attr('class'))
                        $('#mb-current').attr('class', 'mb ' + className);
                }
            });
        }
    });
    deptSelect.change();

    if ($('input[name*=quotation_signed]:checked').val() == 1) {
        if ($('#quotation-signed-error-modal').length > 0) {
            setTimeout(function () {
                $('#quotation-signed-error-modal').dialogMp();
            }, 1000);
        }
    }

    /*ENR_COMB_CDP DISPLAY SCRIPT*/
    enrCdpContainer.change(function () {
        var currentValueCdp = enrCdpContainer.find('input[name="front_simulation[CDP_ENR]"]:checked').val();
        if (currentValueCdp == 1) {
            enrCombCdpContainer.hide();
        } else {
            enrCombCdpContainer.show();
        }
    }).change();

    //TRA-EQ-117 v83
    var VU_WORK_ID_117 = 220;

    function showHideVehicleCategoryQuestion117(inputValue) {
        var $m1Fields       = $('[name*="[VEHICLE_LEGER_M1_MINIMAL]"], [name*="[EU_BATTERIE]"]').closest('.field-container');
        var $inputBeChecked = $('input[name*="[VEHICLE_LEGER_M1_MINIMAL]"][value="2"], input[name*="[EU_BATTERIE]"][value="2"]');
        var $vuFields       = $('[name*="[VU_MASSE]"], [name*="[VU_EEE]"]').closest('.field-container');

        if (inputValue == 1) {
            // Véhicule léger neuf : M1/batterie visibles, VU masqués
            $m1Fields.removeClass('no-visibility').find('input, select').removeAttr('disabled');
            $vuFields.addClass('no-visibility').find('input, select').attr('disabled', 'disabled');
        } else if (inputValue == 2) {
            // Véhicule utilitaire léger neuf : M1/batterie masqués (pré-cochés NON), VU visibles
            $inputBeChecked.prop('checked', true);
            $m1Fields.addClass('no-visibility').find('input, select').attr('disabled', 'disabled');
            $vuFields.removeClass('no-visibility').find('input, select').removeAttr('disabled');
        } else {
            // Pas de sélection : tout masqué
            $inputBeChecked.prop('checked', true);
            $m1Fields.addClass('no-visibility').find('input, select').attr('disabled', 'disabled');
            $vuFields.addClass('no-visibility').find('input, select').attr('disabled', 'disabled');
        }
    }

    function toggleVehicleCategoryQuestion117() {
        var workId = parseInt(workTrigger.find('option:selected').attr('value'));
        if (workId !== VU_WORK_ID_117) {
            $('[name*="[VU_MASSE]"], [name*="[VU_EEE]"]').closest('.field-container').addClass('no-visibility').find('input, select').attr('disabled', 'disabled');
            return;
        }
        // Pour work 220 v83 : seules les options 1 (léger) et 2 (utilitaire léger) sont pertinentes
        $('select[name*="[CAT_VEHICLE_1]"]').find('option[value="3"], option[value="4"], option[value="5"], option[value="6"]').hide();
        showHideVehicleCategoryQuestion117($('select[name*="[CAT_VEHICLE_1]"]').val());
    }

    $(document).on('change', 'select[name*="[CAT_VEHICLE_1]"]', function () {
        showHideVehicleCategoryQuestion117($(this).val());
    });

    /*ENR_COMBDISPLAY SCRIPT*/
    enrContainer.change(function () {
        var currentEnrValue = enrContainer.find('input[name="front_simulation[ENR]"]:checked').val();
        if (currentEnrValue == 1) {
            enrCombContainer.hide().addClass('no-visibility');
        } else {
            enrCombContainer.show().removeClass('no-visibility');
        }
    }).change();

    // ajout du placeholder sur tous les inputs avec unités
    $('form input[type=text][data-unit]').each(function () {
        var unitSpan = $('<span class="text m2">').text($(this).data('unit'));
        $(this).after(unitSpan);
    });

    $('.app-visualise-cdp-contrib-pdf').on('click', function () {
        let $form = $('form[name=app_user_registration]');
        let itemId = $(this).data('item-id');
        ContribVisualiser.visualiseCdpContribPdf($form, 'app_visualise_cdp_contrib_pdf', itemId);
    });

    // BAR-TH-168 : la validation de surface (hideWorkConditions) n'est pas rappelée automatiquement au
    // changement de la surface / de l'usage → on relance checkEligibility sur ces deux champs.
    // NB : on valide sur 'change' (quand on quitte le champ), PAS sur 'keyup' — sinon la saisie de « 10 »
    // déclenche l'erreur dès le « 1 » (< seuil) et vide le champ, empêchant de finir de taper.
    $(document).on('change', '[name$="[SURF_CAPT_SOL]"], [name$="[USAGE_168]"]', function () {
        checkEligibility();
    });

    // BAR-TH-162 : idem pour la surface de capteurs hybrides.
    $(document).on('change', '[name$="[SURF_CAPT_HYB]"]', function () {
        checkEligibility();
    });
});